

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  formData: any = {
    finishAnnex: '',
    finishCondition: '',
    finishDate: '',
    id: '',
  };

  userRules: any = {
    finishDate: [{ required: true, trigger: 'blur', message: '请选择完成日期' }], // 备注
  };

  private editFlag: any = true;
  private headers: any = {};
  private actionUrl: any = ''; // 图片上传
  private fileList: any = [];
  private typeIndex: any = 0;
  private title: any = '';

  private async showDialog(id: any, index: any) {
    this.fileList = [];
    this.typeIndex = index;
    this.editFlag = false;
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.headers.Authorization = localStorage.getItem('token');
    this.formData = {
      finishAnnex: '',
      finishCondition: '',
      finishDate: '',
      id: '',
    };
    this.formData.id = id;
    if (this.typeIndex === 2) {
      this.title = '附件补充';
      this.editFlag = true;
      // 发起接口请求，获取分页数据
      const res = await performanceServer.getSinglePerformanceData(this.formData.id);
      // performanceServer.getSinglePerformanceData(this.formData.id).then((res: any) => {
      if (res.code === '200') {
        this.formData.finishDate = res.data.finishDate;
        this.formData.finishCondition = res.data.finishCondition;
        this.formData.finishAnnex = res.data.finishAnnex;
        this.fileList = res.data.finishAnnexList;
      }
      // });
    } else {
      this.title = '完成任务';
    }
    this.visible = true;
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
    this.typeIndex = 0;
    this.formData = {
      finishAnnex: '',
      finishCondition: '',
      finishDate: '',
      id: '',
    };
    this.fileList = [];
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    if (this.typeIndex === 1) {
      const formComponent: any = this.$refs.form;
      formComponent.validate((valid: any) => {
        if (!valid) {
          return;
        }
        this.finishPerformance();
      });
    } else {
      this.addFinish();
    }
  }

  // 完成点击事件
  finishPerformance() {
    performanceServer
      .finishPerformanceList(this.formData.id, this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('任务完成!');
          this.returnDialog(); // 重新渲染表格数据
          this.$emit('refreshData');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('任务完成失败，请稍后重试！');
      });
  }

  addFinish() {
    performanceServer
      .supplementEnclosure(this.formData.id, {
        finishAnnex: this.formData.finishAnnex,
        finishCondition: this.formData.finishCondition,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('补充提交成功!');
          this.returnDialog(); // 重新渲染表格数据
          this.$emit('refreshData');
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  // 附件
  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.finishAnnex = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.finishAnnex = arr.toString();
  }
  handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }
}
